import { createSlice } from '@reduxjs/toolkit';
import authHelper from '../../helpers/auth.helper';
import { clearList } from './list.slice';

const userSlice = createSlice({
  name: 'user',
  initialState: {
    loggedIn: false,
    details: { is_admin: false },
  },
  reducers: {
    toggleLogin: (state, { payload }) => {
      if (!payload) {
        state.loggedIn = false;
        state.details = { is_admin: false };
      } else {
        state.loggedIn = payload;
      }
    },
    hydrateDetails: (state, { payload }) => {
      state.details = payload.data;
    },
  },
});

export const { toggleLogin, hydrateDetails } = userSlice.actions;
export default userSlice.reducer;

// Compound thunks — these import from other slices, so they live outside createSlice.

// IMPORTANT: This is the Redux logout (local state cleanup only).
// It is NOT the same as the standalone logout() in bxcommon/misc/requests.js
// which makes POST /users/auth/logout (server-side session invalidation).
// Both are separate concerns — see response.interceptor.js and AppHeaderDefault.jsx.
export const logout = () => async (dispatch) => {
  authHelper.removeToken();
  dispatch(toggleLogin(false));
  dispatch(clearList());
  // clearForm is dispatched via the shared action type 'user/clearFormOnLogout'
  // which per-app request slices listen for in extraReducers. See request.slice.js.
  dispatch({ type: 'user/clearFormOnLogout' });
  // Clear RTK Query cache so stale data from the previous user's session
  // is not served on the next login.
  const { api } = await import('../api');
  dispatch(api.util.resetApiState());
};

// initExistingToken chains getUserDetails from RTK Query.
// It is defined as a thunk here, but the actual API call is wired in
// the endpoint files. Components call dispatch(initExistingToken()) in RouteList.
export const initExistingToken = () => async (dispatch) => {
  // Dynamic import to avoid circular dependency: user.slice -> api -> user.endpoints -> user.slice
  const { api } = await import('../api');
  const result = await dispatch(api.endpoints.getUserDetails.initiate(undefined, { forceRefetch: true }));
  if (result.data) {
    dispatch(hydrateDetails(result.data));
  }
  dispatch(toggleLogin(true));
};
